module.exports = __webpack_public_path__ + "static/media/ic_triangle-up-primary.8e260158.svg";